let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8vLs2")).then(() => parcelRequire('5MxR5'));